export default __webpack_public_path__ + "static/logo-507a6045530fd00c1985aa781108bdcb.png";